import { Stack } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from 'react-router-dom';
import { Content } from '../../../../../shared/components/content/content.component';
import {
  ArticleCashAssistTabDataRes,
  CashAssistTabOptionsRes,
} from '../../../services/article.service';
import { ITabState } from '../../../states/tabState.model';
import { ICashAssistTabState, cashAssistTabState } from './cashassist.state';
import { CashAssistForm } from './components/cashassistForm.component';

export const CashAssistTab: FC = () => {
  const { defaultValues, cashAssistTabOptions } = useLoaderData() as ICashassistTab;
  const [isArticleIdExist, setIsArticleIdExist] = useState<boolean>(Boolean(defaultValues?.id));
  const { t } = useTranslation();
  const formMethods = useForm<ArticleCashAssistTabDataRes>({
    mode: 'onChange',
    defaultValues,
  });
  const { watch, reset, resetField } = formMethods;

  useEffect(() => {
    const formStateSub = watch((data: Record<string, any>, reason) => {
      if (reason.type === 'change' && reason.name) {
        const fieldName = reason.name;
        cashAssistTabState.pub.recordData({
          [fieldName]: data[fieldName],
          id: data.id,
        });
      }
    });
    const unsubarticleIdNotExist = cashAssistTabState.sub.articleIdNotExist().subscribe(() => {
      setIsArticleIdExist(false);
      reset({});
    });
    const unsubState = cashAssistTabState.sub
      .state()
      .subscribe(({ action, defaultValues, dataToSave }: IState) => {
        setIsArticleIdExist(true);
        if (action === 'list.selectedArticle') {
          reset(defaultValues);
        } else {
          const name = Object.keys(dataToSave)[0] as keyof typeof dataToSave;
          resetField(name, {
            defaultValue: dataToSave[name],
            keepDirty: false,
          });
        }
      });
    return () => {
      formStateSub.unsubscribe();
      unsubState.unsubscribe();
      unsubarticleIdNotExist.unsubscribe();
    };
  }, []);

  return (
    <>
      {isArticleIdExist ? (
        <Stack
          sx={{
            marginTop: '10px',
          }}
        >
          <CashAssistForm
            formMethods={formMethods}
            cashAssistTabOptions={cashAssistTabOptions as CashAssistTabOptionsRes}
          />
        </Stack>
      ) : (
        <Content
          type='paper'
          paperProps={{
            variant: 'elevation',
            sx: {
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'auto',
              height: '100%',
            },
          }}
          emptyData={{
            value: true,
            title: t('common.no_data'),
          }}
        />
      )}
    </>
  );
};
interface IState extends ICashAssistTabState {
  defaultValues: ArticleCashAssistTabDataRes;
}
interface ICashassistTab extends ITabState {
  defaultValues: ArticleCashAssistTabDataRes;
}
